import { useQuery } from 'react-query';

import { getV2ApiCompanyIdInternationalTransfersTransferId } from 'src/client/spendesk-api';

export function useInternationalTransferGetByPaymentIdQuery({
  paymentId,
  companyId,
  enabled,
}: {
  paymentId: string | undefined;
  companyId: string;
  enabled: boolean;
}) {
  return useQuery(
    ['international-transfer', paymentId],
    async () => {
      if (!paymentId) {
        throw new Error('Payment id is undefined.');
      }

      const result = await getV2ApiCompanyIdInternationalTransfersTransferId({
        path: {
          companyId,
          id: paymentId,
        },
      });

      if (result.statusCode !== 200) {
        throw new Error('Failed to fetch transfer by payment id.');
      }

      return result.body.data;
    },
    {
      enabled,
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 60 * 1000, // Stale for 30 minutes
      cacheTime: 30 * 60 * 1000, // Cache after 30 minutes
    },
  );
}
